/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { Box } from "@mui/material";
import {
  DataGrid,
  GridColDef,
  GridClasses
} from "@mui/x-data-grid";
import { Tooltip, IconButton } from "@mui/material";
import { AiOutlineFileSearch } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

type RowData = {
  id: string;
  suba_name: string;
};

const ReceiverAccountList: React.FC<{
  isLoading: boolean;
  page: number;
  pageSize: number;
  rowCount: number;
  tableData: RowData[];
  setPaginationModel: any;
  currentLastKey: string;
}> = ({ isLoading, page, pageSize, rowCount, tableData, setPaginationModel, currentLastKey }) => {

  const navigate = useNavigate();
  const userRole = localStorage.getItem("userRole")?.toLowerCase();

  const columns: GridColDef[] = [
    { field: "suba_name", headerName: "Subaccount", minWidth: 150, sortable: false, flex: 1 },
    {
      field: "actions", headerName: "", sortable: false, flex: 1,
      headerAlign: 'right',
      align: 'right',
      renderCell: (params) => {
        return (
          <Tooltip title="View More Details" arrow placement="right">
            <div className="mr-5">
              <IconButton
                id={"button-detail-" + params?.row?.id}
                onClick={() => handleClickDetail(params.row.id)}
              >
                <AiOutlineFileSearch className="h-5 w-5 text-navy-700" />
              </IconButton>
            </div>
          </Tooltip>
        );
      },
    },
  ];

  const handleClickDetail = (id: any) => {
    navigate(`/${userRole}/merchants/subaccounts/${id}`);
  };

  const customDataGridStyles: Partial<GridClasses> = {
    root: 'mui-table-custom',
    columnHeader: 'text-start',
    row: ''
  };

  const handleClickDetails = (id: any) => {
  };

  return (
    <div className="p-8">
      <Box
      >
        <DataGrid
          sx={{
            '& .MuiDataGrid-cell': {
              padding: '8px 16px',
            },
            '& .MuiDataGrid-columnHeader': {
              padding: '8px 16px',
            },
            "& .MuiTablePagination-input": {
              marginRight: "-20px"
            },
            "& .MuiTablePagination-displayedRows": {
              display: "none"
            },
          }}
          loading={isLoading}
          rows={tableData || []}
          columns={columns}
          getRowId={(row) => row.id}
          rowCount={rowCount}
          sortingMode="server"
          paginationMode="server"
          pageSizeOptions={[10, 25, 50, 100]}
          rowHeight={40}
          columnHeaderHeight={40}
          paginationModel={{ page: page, pageSize: pageSize }}
          onPaginationModelChange={(newValue) => setPaginationModel(newValue)}
          disableRowSelectionOnClick
          disableColumnFilter
          disableColumnMenu
          classes={customDataGridStyles}
          hideFooter={currentLastKey === "" && page === 0}
          autoHeight
        />
      </Box>
    </div>
  );
};

export default ReceiverAccountList;